import categoriesEnum from './categories.json';

export const categoriesConstants = {
  categoriesEnum,
};
